import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Button, Select, Input } from '@driftt/tide'
import { Link, Prompt } from 'react-router-dom'
import Editor from 'components/Editor'
import ArticleActionButtons from 'components/Article/ArticleActionButtons'
import DeleteArticleContent from 'components/DeleteModalContent/DeleteArticleContent'
import cx from 'classnames'


import {
  getArticle,
  getArticleChanged,
  getFetchArticleLoaded,
  getArticleCategoryById,
  getArticleSectionById,
  getArticleErrors,
} from 'modules/knowledgebase/selectors';

import * as actions from 'modules/knowledgebase/actions'

import { selectOptions } from 'modules/knowledgebase/model';

import './style.css'


const ArticleBreadcrumbs = ({category, section}) => (
  <div className="article-header-breadcrumbs">
    {!section ?
      <Link
        className="article-header-breadcrumbs-link"
        to={`/category/${category.id}`}
      >
        {`Drift Help / ${category.name} /`}
      </Link> :
      <Link
        className="article-header-breadcrumbs-link"
        to={`/category/${category.id}/${section.id}`}
      >
        {`Drift Help / ${category.name} / ${section.name} /`}
      </Link>
    }
  </div>
)

const ArticleTitle = ({ title, setTitle, titleErrors = [] }) => (
  <div className="article-title-name-edit">
    <Input
      value={title}
      icon="edit-1"
      onChange={setTitle}
      className={cx('article-title-name-edit-input', { error: titleErrors.length > 0 })}
      required
    />    
    {titleErrors && titleErrors.map(te => {
      return <span key={te.message} className="input-error-message">{te.message}</span>
    })}
  </div>
)

const EditorHeader = props => (
  <div className="article-header">
    <ArticleTitle setTitle={props.setTitle} title={props.title} titleErrors={props.errors.filter(e => e.title)} />
    <div className="article-header-right">
      <ArticleActionButtons isEditing={props.isEditing} />
      <Select
        options={selectOptions}
        value={props.articleStatus}
        onChange={props.onSelectValueChange}
        className="article-status-selector"
        clearable={false}
      />
      <Button
        loading={props.saving}
        disabled={props.disableButton} onClick={props.isEditing ? props.editArticle : props.createArticle}
      >
        Save
      </Button>
    </div>
  </div>
)

class Article extends Component {
  state = {
    isModalOpen: false
  }
  
  componentDidMount() {
    const { actions, match, isEditing } = this.props
    
    window.addEventListener("beforeunload", this.handleUnload)
    
    isEditing ? actions.fetchArticle({orgId: this.props.orgId, slug: match.params.slug}) : actions.clearArticle()
    actions.fetchCategories(this.props.orgId) // Todo: investigate ways to not fetch categories here if it is already fetched when this component mounts
  }
  
  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleUnload)
  }
   
  saveClicked = null
  
  handleUnload = event => {
    const { articleChanged } = this.props
    
    if (articleChanged && !this.saveClicked) {
      this.saveClicked = false
      event.returnValue = "prompt"
    }
  }
  
  setTitle = e => {
    const { actions } = this.props
    const title = e.target.value
    
    actions.setTitle(title)
    
    actions.checkTitle({orgId: this.props.orgId, title: title})
  }
  
  createArticle = () => {
    const { actions } = this.props
    this.saveClicked = true
    actions.createArticle()
  }
  
  editArticle = () => {
    const { actions } = this.props
    actions.editArticle()
  }
  
  handleSelectValueChange = ({ value }) => {
    const { actions } = this.props
    actions.setStatus(value)
  }
  
  handleDeleteArticle = () => {
    this.setState({isModalOpen: true})
  }
  
  handleCloseModal = () => {
    this.setState({isModalOpen: false})
  }
  
  render() {
    const { article, isArticleLoaded, isEditing, categoryArticleBelongsTo, sectionArticleBelongsTo, articleChanged, errors = []} = this.props
    const { isModalOpen } = this.state
    
    if (!isArticleLoaded && isEditing) return null

    const isError = errors.length > 0;
    
    return (
      <div>
        <Prompt message={() =>
          articleChanged ? "Are you sure you want to leave this page? You will lose your unsaved changes" : true }
          when={articleChanged}
        />
        
        {categoryArticleBelongsTo &&
          (
            <ArticleBreadcrumbs
              category={categoryArticleBelongsTo}
              section={sectionArticleBelongsTo}
            />
          )
        }
        <EditorHeader
          setTitle={this.setTitle}
          title={article.title}
          createArticle={this.createArticle}
          editArticle={this.editArticle}
          disableButton={!this.props.articleChanged || isError}
          onSelectValueChange={this.handleSelectValueChange}
          articleStatus={article.status}
          isEditing={this.props.isEditing}
          saving={article.isSaving}
          errors={errors}
        />
        <div className="article-wrapper">
          <Editor
            onDeleteArticleClick={this.handleDeleteArticle}
            isEditing={this.props.isEditing}
          />
        </div>
        {isModalOpen &&
          <DeleteArticleContent
            isFromEditor={this.props.isEditing}
            onCloseModal={this.handleCloseModal}
            isOpen={isModalOpen}
          />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  article: getArticle(state),
  errors: getArticleErrors(state),
  orgId: state.user.orgId,
  articleChanged: getArticleChanged(state),
  categoryArticleBelongsTo: getArticleCategoryById(state, getArticle(state).categoryId),
  sectionArticleBelongsTo: getArticleSectionById(state, getArticle(state).sectionId),
  isArticleLoaded: getFetchArticleLoaded(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setTitle: actions.setTitle,
    checkTitle: actions.checkTitle,
    setStatus: actions.setStatus,
    editArticle: actions.editArticle,
    fetchArticle: actions.fetchArticle,
    fetchCategories: actions.fetchCategories,
    createArticle: actions.createArticle,
    clearArticle: actions.clearArticle
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Article)